export const commonEnvironment = {
	// Cloudflare Turnstile public site key (safe to expose). Empty disables the widget.
	turnstileSiteKey: '0x4AAAAAADqfD6MkUn6i3QD_',
	articleServiceUrl: '/article-api/v1/',
	outlineServiceUrl: '/outline-api/v1/',
	boardServiceUrl: '/board-api/v1',
	projectServiceUrl: '/project-api/v1/',
	accountServiceUrl: '/account-api/v1',
	changetrackerServiceUrl: '/changetracker-api/v1/',
	bomServiceUrl: '/bom-api/v1/',
	maintenanceServiceUrl: '/maintenance-api/v1',
	quotationServiceUrl: '/quotation-api/v1/',
	sceneServiceUrl: '/scene-api/v1/',
};

export function addBaseUrlToUrls(environment, commonEnvironment) {
	Object.keys(commonEnvironment).forEach((key: string) => {
		if (key.includes("Url")) {
			environment[key] = environment.baseUrl + commonEnvironment[key];
		}
	});
}
